var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"nrk tabulation",on:{"click":_vm.clickid}},_vm._l((_vm.data),function(item,index){return _c('li',{key:index},[_c('img',{attrs:{"src":_vm.Http+item.src,"data-id":item.id}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }